// extracted by mini-css-extract-plugin
export var alignCenter = "_6t-d";
export var bannerShown = "_6t-6";
export var buttonContent = "_6t-0";
export var cardList = "_6t-1";
export var centerContent = "_6t-2";
export var chevron = "_6t-3";
export var closePanelButton = "_6t-k";
export var conversationContextContainer = "_6t-l";
export var conversationDetailContainer = "_6t-4";
export var detailWrapper = "_6t-7";
export var dropdownButton = "_6t-e";
export var dropdownTitle = "_6t-9";
export var fullHeight = "_6t-5";
export var hidden = "_6t-a";
export var icon = "_6t-b";
export var mergeSuggestionWrapper = "_6t-m";
export var panel = "_6t-i";
export var portalButtonsWrapper = "_6t-c";
export var right = "_6t-j";
export var tableSummaryContainer = "_6t-8";
export var tableSummaryHeader = "_6t-g";
export var threeDotsButton = "_6t-f";
export var wide = "_6t-h";